import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import SmoothScroll from "@/components/SmoothScroll";
import { NoiseOverlay } from "@/components/NoiseOverlay";
import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/Seo";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Music from "@/pages/Music";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Events from "@/pages/Events";
import PastEvents from "@/pages/PastEvents";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <SmoothScroll>
          <NoiseOverlay />
          <Toaster position="top-center" richColors />
          <Layout>
            <Seo />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/music" element={<Music />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/past" element={<PastEvents />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/es" element={<Home />} />
              <Route path="/es/about" element={<About />} />
              <Route path="/es/music" element={<Music />} />
              <Route path="/es/services" element={<Services />} />
              <Route path="/es/gallery" element={<Gallery />} />
              <Route path="/es/events" element={<Events />} />
              <Route path="/es/events/past" element={<PastEvents />} />
              <Route path="/es/contact" element={<Contact />} />
            </Routes>
          </Layout>
        </SmoothScroll>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
